import React, {useEffect, useState} from "react";
import {
    Button, Glyphicon,
    Modal,
    ModalBody,
    ModalHeader,
    ModalTitle, Table
} from "react-bootstrap";
import {
    clientImportTimePadSettingsDelete,
    clientImportTimePadSettingsGet, clientImportTimePadSettingsGetOne
} from "../../../../api/cp";
import {useEventContext} from "../../../context";
import EventSettingsForm from "./EventSettingsForm";
import moment from "moment";
import RequestAccessForm from "./RequestAccessForm";

export const ClientImportTimePad = () => {
    const {event} = useEventContext();
    const [settingsList, setSettingsList] = useState(null);
    const [currentSettings, setCurrentSettings] = useState(null);

    useEffect(async () => {
        const settingsList = await clientImportTimePadSettingsGet(event.eventKey);
        setSettingsList(settingsList);
        if (!settingsList?.length) {
            setCurrentSettings({});
        }
    }, []);

    const handleCreateSettings = (settings) => {
        setSettingsList(settingsList.concat(settings));
        setCurrentSettings(settings);
    }

    const handleEditSettings = async (id) => {
        const settings = await clientImportTimePadSettingsGetOne(event.eventKey, id);
        setCurrentSettings(settings);
    }

    const handleDeleteSettings = async (id) => {
        const text = 'Точно удалить настройки импрота?';
        if (!confirm(text)) {
            return;
        }

        await clientImportTimePadSettingsDelete(event.eventKey, id);
        setSettingsList(settingsList.filter((settings) => settings.id !== id));
    }

    const handleCloseSettings = () => {
        setCurrentSettings(null);
    }

    if (null === settingsList) {
        return (
            <p>Загрузка источников импорта</p>
        );
    }

    if (currentSettings) {
        if (!currentSettings.accessToken || !currentSettings.settings.organizationId) {
            return (
                <RequestAccessForm onSuccess={handleCreateSettings} onClose={handleCloseSettings} />
            );
        }

        return (
            <EventSettingsForm settings={currentSettings} onClose={handleCloseSettings} />
        );
    }

    return (
        <>
            <Table>
                <thead>
                <tr>
                    <th>Название</th>
                    <th>Последний запуск</th>
                    <th width={100} />
                </tr>
                </thead>
                <tbody>
                {settingsList.map(({id, name, lastPullAt}) => (
                    <tr key={id}>
                        <td>{name}</td>
                        <td>{lastPullAt ? moment.unix(lastPullAt).format('LLL') : 'Нет'}</td>
                        <td>
                            <Button onClick={() => handleEditSettings(id)} bsSize="small">
                                <Glyphicon glyph={"pencil"} />
                            </Button>
                            <Button onClick={() => handleDeleteSettings(id)} bsSize="small">
                                <Glyphicon glyph={"trash"} />
                            </Button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>
            <p>
                <Button onClick={() => setCurrentSettings({})}>Добавить источник</Button>
            </p>
        </>
    );
}

export const ClientImportTimePadModal = ({visible, onClose}) => {
    return (
        <Modal show={visible} onHide={onClose} bsSize="large">
            <ModalHeader closeButton>
                <ModalTitle>Импорт зрителей из TimePad</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <ClientImportTimePad />
            </ModalBody>
        </Modal>
    );
}
